import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { IFormBuilder, IFormGroup } from '@rxweb/types';
import moment from 'moment-timezone';
import { ApiService, SessionService, Sim } from 'pod-ng-core';

export interface IUsageParams {
  billTime: string;
  accountId: string;
}

interface IUsageParamsModel {
  range: number;
  accountId: string;
}

@Component({
  selector: 'app-usage-params',
  templateUrl: './usage-params.component.html',
})
export class UsageParamsComponent implements OnInit {
  private _iccid: string;
  @Input() get iccid(): string {
    return this._iccid;
  }
  set iccid(iccid: string) {
    if (this.iccid !== iccid) {
      this._iccid = iccid;
      this.getSim();
    }
  }

  @Output() onChange = new EventEmitter<IUsageParams>();

  public currentAccount = this.session.account;
  public sim: Sim;

  private formBuilder: IFormBuilder;
  public form: IFormGroup<IUsageParamsModel>;

  constructor(
    formBuilder: UntypedFormBuilder,
    private apiService: ApiService,
    private session: SessionService
  ) {
    this.formBuilder = formBuilder;
  }

  public ngOnInit() {
    this.form = this.formBuilder.group<IUsageParamsModel>({
      range: 0,
      accountId: this.session.account.getId(),
    });

    // Init billTime
    this.emitSearchParams();
    this.form.valueChanges.subscribe(() => this.emitSearchParams());
  }

  private setAccountId(newAccountId) {
    if (newAccountId !== this.form.controls.accountId.value) {
      this.form.controls.accountId.setValue(newAccountId);
    }
  }

  private getSim() {
    if (this.iccid) {
      this.apiService.getItem<Sim>(Sim, this.iccid).subscribe(sim => {
        this.sim = sim;
        this.setAccountId(this.sim.ownership[0]);
      });
    } else {
      this.sim = null;
      this.setAccountId(this.session.account.getId());
    }
  }

  public emitSearchParams() {
    const { range, accountId } = this.form.value;
    this.onChange.emit({
      billTime:
        moment().utc().subtract(range, 'month').startOf('month').format() +
        ',' +
        moment().utc().subtract(range, 'month').endOf('month').format(),
      accountId,
      ...(this.iccid ? { iccid: this.iccid } : {}),
    });
  }
}
